@if (sessionExpired.isOpen()) {
  <div
    class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/45 px-4 py-6"
    role="dialog"
    aria-modal="true"
    aria-labelledby="session-expired-title"
    aria-describedby="session-expired-description"
  >
    <div class="w-full max-w-md rounded-2xl bg-white shadow-[0_24px_70px_rgba(0,0,0,0.18)] overflow-hidden">
      <div class="relative px-6 pt-6 pb-5 border-b border-ui-border text-center">
        <div class="mx-auto w-11 h-11 rounded-full bg-status-warning-bg text-status-warning flex items-center justify-center">
          <fa-icon [icon]="faTriangleExclamation" class="text-xl" />
        </div>

        <button
          type="button"
          class="absolute right-5 top-5 w-8 h-8 rounded-full flex items-center justify-center text-ink-muted hover:text-ink hover:bg-black/5 transition-colors cursor-pointer"
          aria-label="Cerrar aviso"
          (click)="dismiss()"
        >
          <fa-icon [icon]="faXmark" class="text-sm" />
        </button>

        <h2 id="session-expired-title" class="mt-4 text-xl font-semibold text-ink leading-7">
          Tu sesión ha caducado
        </h2>

        <p id="session-expired-description" class="mt-2 text-sm text-ink-secondary leading-6">
          Por motivos de seguridad, tu sesión ha finalizado.<br>
          Vuelve a iniciar sesión para continuar.
        </p>
      </div>

      <div class="px-6 py-4 flex justify-end bg-brand-bg">
        <button
          type="button"
          class="h-11 px-5 rounded-sm bg-brand-btn text-white text-sm font-bold hover:bg-brand focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2 transition-colors cursor-pointer"
          (click)="dismiss()"
        >
          Iniciar sesión
        </button>
      </div>
    </div>
  </div>
}
